import { gql } from 'graphql-request';

export const getActiveSubscriptions = gql`
  query GetActiveSubscriptions($userId: Int!) {
    getActiveSubscriptions(userId: $userId) {
      id
      status
      currentPeriodStart
      currentPeriodEnd
    }
  }
`;

export const purchaseSubscription = gql`
  mutation PurchaseSubscription(
    $userId: Int!
    $priceName: String!
    $paymentMethod: String!
  ) {
    purchaseSubscription(
      userId: $userId
      priceName: $priceName
      paymentMethod: $paymentMethod
    )
  }
`;

export const cancelSubscription = gql`
  mutation CancelSubscription($userId: Int!) {
    cancelSubscription(userId: $userId)
  }
`;
